import { Effect } from "../Materials/effect";
var name = 'clearQuadPixelShader';
var shader = "[[block]] struct Uniforms {\n[[offset(0)]] color : vec4<f32>;\n};\n[[binding(0),set(0)]] var<uniform> uniforms : Uniforms;\n[[location(0)]] var<out> outColor : vec4<f32>;\n[[stage(fragment)]]\nfn main() -> void {\noutColor=uniforms.color;\nreturn;\n}\n";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var clearQuadPixelShader = { name: name, shader: shader };
//# sourceMappingURL=clearQuad.fragment.js.map